<template>
  <div class="content--sinoreg Resumo">
    <header-blue>
      <h4 class="resumo-show_title pl-2 mt-3">
        <span class="pt-3 resumo-show_title-label">
          Gerenciador de tarefas
        </span>
      </h4>
    </header-blue>

    <b-tabs v-model="tabIndex"
            content-class=""
            class="Resumo-border"
            align="left"
            active-nav-item-class="Resumo--tab-active">
      <b-tab>
        <template v-slot:title>
          Carga
        </template>

        <gerenciador-busca ref="GerenciadorBusca"
                           :prop-pagination="pagination"
                           :prop-order="order"
                           @onGetTarefas="(tarefas) => data = tarefas" />
        <gerenciador-resultados class="mt-4"
                                :prop-data="data"
                                @onCumprirTodos="buscarTarefas()"
                                @onChangePage="(data, order) => changePagination(data, order)" />
      </b-tab>

      <b-tab>
        <template v-slot:title>
          Comunicações
        </template>
        <Comunicacoes />
      </b-tab>

      <b-tab>
        <template v-slot:title>
          Anotações
        </template>
        <Anotacoes />
      </b-tab>

      <b-tab v-if="!itemDisabled">
        <template v-slot:title>
          Documentos pendentes de assinatura
        </template>
        <DocumentosPendentes />
      </b-tab>

      <b-tab>
        <template v-slot:title>
          Comunicação SEADE
        </template>
        <Seade />
      </b-tab>
      <b-tab>
        <template v-slot:title>
          Casamentos e habilitações
        </template>
        <CasamentoEHabilitacoes />
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <icon-svg icon="qrcode"
                    class="icon--sm" />
          Vinculações Selos
        </template>
        <ListagemSelosGerenciador />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  /* componentes */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import GerenciadorBusca from "@/components/SofiaRei/Gerenciador/GerenciadorBusca"
  import GerenciadorResultados from "@/components/SofiaRei/Gerenciador/GerenciadorResultados"
  import Seade from "@/components/SofiaRei/Gerenciador/Seade/Seade"
  import DocumentosPendentes from "@/components/SofiaRei/Gerenciador/DocumentosPendentes/DocumentosPendentes"
  import Comunicacoes from "@/components/SofiaRei/Gerenciador/Comunicacoes/Comunicacoes"
  import Anotacoes from "@/components/SofiaRei/Gerenciador/Anotacoes/Anotacoes"
  import CasamentoEHabilitacoes from "@/components/SofiaRei/Gerenciador/TarefasCasamento/CasamentoEHabilitacoes"
  import ListagemSelosGerenciador from "@/components/SofiaRei/Gerenciador/ListagemSelosGerenciador"

  export default {
    name: "Gerenciador",
    components: {
      HeaderBlue,
      GerenciadorBusca,
      GerenciadorResultados,
      DocumentosPendentes,
      Comunicacoes,
      Seade,
      CasamentoEHabilitacoes,
      ListagemSelosGerenciador,
      Anotacoes
    },
    data () {
      return {
        itemDisabled: true,
        tabIndex: 0,
        data: {},
        pagination: {
          lastPage: 0,
          page: 1,
          perPage: 20
        },
        order: 'data_inclusao'
      }
    },
    methods: {
      buscarTarefas () {
        this.$refs.GerenciadorBusca.buscarTarefas()
      },
      changePagination (pagination, order) {
        this.order = order
        Object.assign(this.pagination, pagination)
      }
    }
  }
</script>

<style  lang="scss">
  @import "../../scss/_components/resumos";
</style>
